export const DOCS_ATTACHMENT_SCHEME = 'docs-attachment:';

const ATTACHMENT_ID_PATTERN =
  /^docs-attachment:([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/i;

const ATTACHMENT_ID_GLOBAL =
  /docs-attachment:([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})/gi;

export function buildDocsAttachmentSrc(attachmentId: string): string {
  return `${DOCS_ATTACHMENT_SCHEME}${attachmentId}`;
}

export function parseDocsAttachmentId(src?: string | null): string | null {
  if (!src) return null;
  const match = ATTACHMENT_ID_PATTERN.exec(src.trim());
  return match?.[1] ?? null;
}

export function extractDocsAttachmentIds(content: string): string[] {
  if (!content) return [];
  const ids = new Set<string>();
  const pattern = new RegExp(ATTACHMENT_ID_GLOBAL.source, ATTACHMENT_ID_GLOBAL.flags);
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(content)) !== null) {
    if (match[1]) ids.add(match[1]);
  }
  return Array.from(ids);
}

export function replaceDocsAttachmentUrls(
  content: string,
  urlByAttachmentId: Record<string, string>,
): string {
  if (!content) return content;
  return content.replace(ATTACHMENT_ID_GLOBAL, (full, id: string) => {
    const url = urlByAttachmentId[id];
    return url && url.trim() ? url : full;
  });
}

/** Permite data:image e docs-attachment no react-markdown (default bloqueia ambos). */
export function documentationMarkdownUrlTransform(value: string): string {
  const trimmed = value.trim();
  if (trimmed.startsWith('data:image/')) return trimmed;
  if (parseDocsAttachmentId(trimmed)) return trimmed;

  const colon = trimmed.indexOf(':');
  const questionMark = trimmed.indexOf('?');
  const numberSign = trimmed.indexOf('#');
  const slash = trimmed.indexOf('/');

  if (
    colon === -1 ||
    (slash !== -1 && colon > slash) ||
    (questionMark !== -1 && colon > questionMark) ||
    (numberSign !== -1 && colon > numberSign)
  ) {
    return trimmed;
  }

  const protocol = trimmed.slice(0, colon).toLowerCase();
  if (protocol === 'http' || protocol === 'https' || protocol === 'mailto' || protocol === 'tel') {
    return trimmed;
  }

  return '';
}
